import { Typography } from "@circle-react-uikit/Typography";

export const PropertyLine = ({ children, title }: any) => (
  <div className="flex flex-col gap-y-1">
    <Typography.LabelSm weight="semibold">{title}</Typography.LabelSm>
    {children}
  </div>
);
